import { useNavigate } from 'react-router';

import { ProjectAbstract } from '@/domain/project/entities/project.entity';
import { selectProjectFestivalItems } from '@/domain/project-festival/project-festival.selectors';
import { selectIsFetchingProjectsFestival } from '@/domain/project-festival/project-festival.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { ProjectsPageList } from '@/ui/pages/app/components/projects-page/ProjectsPageList';
import { ProjectsPageTitleAndCreateButton } from '@/ui/pages/app/components/projects-page/ProjectsPageTitleAndCreateButton';
import { ButtonModalCreateProjectFestival } from '@/ui/pages/app/project/festival/projects/components/ButtonModalCreateProjectFestival';

export function ProjectsFestival() {
  const projectItems: ProjectAbstract[] = useAppSelector(
    selectProjectFestivalItems,
  );
  const isFetchingProjects = useAppSelector(selectIsFetchingProjectsFestival);
  const isProjectItemsEmpty = projectItems.length === 0;

  const navigate = useNavigate();
  const onClickProject = (projectId: number) => {
    navigate(`/app/projects/festival/${projectId}`);
  };

  return (
    <>
      <ProjectsPageTitleAndCreateButton
        title={translate('ProjectsFestival.my-events')}
        createButton={<ButtonModalCreateProjectFestival />}
        showCreateButton={isProjectItemsEmpty === false}
      />
      <ProjectsPageList
        projectItems={projectItems}
        isFetchingProjects={isFetchingProjects}
        onClickProject={onClickProject}
        noProjectMessage={translate('ProjectsFestival.no-project-message')}
        createButton={<ButtonModalCreateProjectFestival />}
      />
    </>
  );
}
